module.exports = __webpack_public_path__ + "img/orders.4cb1d3d9.svg";